module.exports = __webpack_public_path__ + "static/media/r129.57527b5d.jpg";